import axios from "axios";
axios.defaults.withCredentials = true;
import errorHandler from "@/scripts/errorHandler";
import { getApiBaseUrl } from "@/utils/RuntimeConfig";
import qs from "qs";

// 配置API接口地址（通过运行时 config.js 注入，无 config.js 时默认同源）
let baseApi = getApiBaseUrl() + "/";
export default class Axios2 {

  static getTokenFromUrl() {
    try {
      const urlParams = new URLSearchParams(window.location.search);
      const tokenFromUrl = urlParams.get("token");

      if (tokenFromUrl) {
        // JWT格式验证
        const isValidFormat = /^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+$/.test(tokenFromUrl);

        if (!isValidFormat) {
          console.error("❌ URL参数token格式非法");
          return null;
        }

        sessionStorage.setItem("token", tokenFromUrl);

        // 清理URL
        const cleanUrl = window.location.pathname + window.location.hash;
        window.history.replaceState({}, document.title, cleanUrl);

        console.log("✅ Token已从URL参数自动注入sessionStorage");
        return tokenFromUrl;
      }
    } catch (error) {
      console.error("获取URL参数token失败:", error);
    }
    return null;
  }

  static getToken() {
    const tokenFromUrl = Axios2.getTokenFromUrl();
    if (tokenFromUrl) {
      return tokenFromUrl;
    }
    const tokenFromStorage = localStorage.getItem("token");
    if (tokenFromStorage) {
      return tokenFromStorage;
    }
    console.warn("⚠️ 未找到可用的token，请重新登录");
    return null;
  }

  static clearToken() {
    localStorage.removeItem("token");
    delete axios.defaults.headers.common["authorization"];
  }

  static ajax(options) {
    return new Promise((resolve, reject) => {
      const token = Axios2.getToken();

      if (!token) {
        if (window.location.pathname !== '/login') {
          window.location.href = '/login?redirect=' + encodeURIComponent(window.location.href);
        }
        reject({
          success: false,
          message: "认证失败：未找到有效的token",
          code: 401
        });
        return;
      }

      axios.defaults.headers.common["authorization"] = token;

      axios({
        url: options.url,
        method: options.method || 'POST',
        baseURL: baseApi,
        timeout: 80000,
        data: options.data || null,
        params: options.params || null,
        paramsSerializer: params => qs.stringify(params, { arrayFormat: 'repeat' }),
        headers: options.headers || {}
      })
        .then((response) => {
          if (errorHandler.handleRequestRes(response)) {
            resolve(response.data);
          } else {
            reject(response.data);
          }
        })
        .catch((error) => {
          // ✅ 修正后的语法（传统&&写法）
          if (error.code === 401) {
            Axios2.clearToken();
            window.location.href = '/login?error=expired';
          }
          reject(error);
        });
    });
  }
}
